<template>
  <svg
    width="14px"
    height="10px"
    viewBox="0 0 14 10"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g
        id="btn_Primary-default"
        transform="translate(-224.000000, -25.000000)"
        fill="currentColor"
      >
        <g id="btn_Primary">
          <g
            id="Actions-/-Navigation-/-arrow--right-/-16"
            transform="translate(223.000000, 22.000000)"
          >
            <polygon
              id="Fill"
              points="9.3 3.7 13.1 7.5 1 7.5 1 8.5 13.1 8.5 9.3 12.3 10 13 15 8 10 3"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'ArrowRight'
};
</script>
